// extracted by mini-css-extract-plugin
module.exports = {"Banner":"Banner_Banner__37PF0","Letters":"Banner_Letters__2y-8J"};